import { graphql } from '@shared/api/gql';

export const feedQueryDocument = graphql(`
	query GetFeedIssueStarmagazine(
		$id: ID!
		$sortKey: ArticleSortKeys
		$reverse: Boolean
		$limit: Int
	) {
		issue(id: $id) {
			id
			name
			slug
			articles(sortKey: $sortKey, reverse: $reverse, limit: $limit) {
				id
				name
				ArticleID
				created
				updated
				releaseDate
				thumbnail
				featureImage
				slug
				description
			}
		}
	}
`);

export const issuesQueryDocument = graphql(`
	query GetIssuesStarmagazine(
		$sortKey: IssueSortKeys
		$limit: Int
		$reverse: Boolean
		$offset: Int
	) {
		issues(
			sortKey: $sortKey
			limit: $limit
			reverse: $reverse
			offset: $offset
		) {
			id
			name
			description
			features
			cover
			externalUrl
			price
			currency
			slug
			data
			releaseDate
			updated
			isPaid
			created
			isPurchased
		}
	}
`);

export const sectionsQueryDocument = graphql(`
	query GetSectionsStarmagazine(
		$sortKey: IssueSortKeys
		$limit: Int
		$reverse: Boolean
		$offset: Int
	) {
		sections {
			id
			position
			name
			issues(
				sortKey: $sortKey
				limit: $limit
				reverse: $reverse
				offset: $offset
			) {
				id
				name
				description
				features
				cover
				externalUrl
				price
				currency
				slug
				data
				releaseDate
				updated
				isPaid
				created
				isPurchased
			}
		}
	}
`);
